import axios from "axios";
import ErrorParser from '../../services/error.parser';

const ProvidersService = {
  providers: async function () {
    const requestData = {
      method: "get",
      url: "/api/providers", 
    };
    try {
      const response = await axios(requestData);
      return JSON.parse(response.data);
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },
  provider: async function () {
    const requestData = {
      method: "get",
      url: "/api/providers/website", 
    };
    try {
      const response = await axios(requestData);
      return JSON.parse(response.data);
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },
};

export default ProvidersService;

